import * as Sentry from '@sentry/browser';

export default class ErrorTracking {
  static configureScope() {
    Sentry.configureScope((scope) => {
      /* eslint-disable */
      scope.setTag('carshareCorpId', CARSHARE_CORP_ID);
    });
  }

  static captureException(err) {
    Sentry.captureException(err);
  }

  static showReportDialog() {
    Sentry.showReportDialog();
  }

  static captureMessage(message) {
    Sentry.captureMessage(message);
  }
}
